import { DataContext } from "@/types";
import { Data } from "../Data";
import { BillingPlan } from "./BillingPlan";

export class BillingPlans extends Data {
  static instance: BillingPlans | null = null;
  groups: BillingPlan[] = [];
  enterprisePlan?: BillingPlan;

  constructor(options: any) {
    super({
      api: "/Organization/BillingPlans",
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...options
    });

    this.groups = [];
  }

  onDataReceived(data: any) {
    data.billingPlans.forEach((p: any) => {
      const plan = new BillingPlan(p);
      this.groups.push(plan);
    });

    this.enterprisePlan = this.groups.find((p) => p.name === "Enterprise");
    this.enterprisePlan && (this.enterprisePlan.isCustom = true);
  }

  static getBillingPlans(context: DataContext, updateCache?: boolean): Promise<BillingPlans> {
    return new Promise((resolve, reject) => {
      if (BillingPlans.instance && updateCache !== true)
        resolve(BillingPlans.instance);
      else BillingPlans.instance = new BillingPlans({ resolve, reject, context });
    });
  }
}
